import React, { Component } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputText, CustomCheckbox, Btn } from '../../../../components'
import * as GrupoHttp from '../../../../services/api/https/settings/group.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

class ModalGrupoUsuario extends Component {
  constructor(props) {
    super(props)
    if (props.data) {
      const { id, name, actived } = props.data
      this.state = { id, name, actived }
    } else {
      this.state = { id: null, name: '', actived: true }
    }
  }
  onFormContentChange = (name, value) => {
    this.setState(state => (state[name] = value))
  }
  onBtnSalvarClicked = async () => {
    try {
      const { id, name, actived } = this.state
      if (name.trim().length < 3) {
        throw new Error('Nome Grupo Incorreto')
      }
      const grupo = await GrupoHttp.saveGroup({ id, name, actived })
      this.props.onModalSave(grupo)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  render() {
    const { show, onModalClose } = this.props
    const { name, actived } = this.state
    return (
      <CustomModal header="Grupo de Usuário" isVisible={show} onClose={onModalClose}>
        <form className="p-grid">
          <div className="p-col-12">
            <InputText
              label="Descrição :"
              marginTop={10}
              value={name}
              onChange={value => this.onFormContentChange('name', value)}
            />
          </div>
          <div className="p-col-12">
            <CustomCheckbox
              onChange={value => this.onFormContentChange('actived', value)}
              checked={actived}
            >
              Ativo
            </CustomCheckbox>
          </div>
          <div className="p-col-12">
            <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
          </div>
        </form>
      </CustomModal>
    )
  }
}
export default connect()(ModalGrupoUsuario)
